import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SobreNos from "../pages/sobre-nos/page";
import Servicos from "../pages/servicos/page";
import Vantagens from "../pages/vantagens/page";
import Contato from "../pages/contato/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre-nos",
    element: <SobreNos />,
  },
  {
    path: "/servicos",
    element: <Servicos />,
  },
  {
    path: "/vantagens",
    element: <Vantagens />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
